import block from 'bem-cn'
import React from 'react'
import { useSelector } from 'react-redux'
import ReactDOM from 'react-dom'
import { AnimatePresence, motion } from 'framer-motion'

import { selectLocaleDict } from 'features/locale/selectors'

import useHideOverflow from 'shared/hooks/useHideOverflow'

import { ReactComponent as CloseImg } from 'shared/img/modal-close.svg'

import './Modal.scss'
import Button from '../UIKit/Button/Button'

interface IModalProps {
  open: boolean
  handleClose: () => void
  bgColor?: string
  position?: 'default' | 'center'
  hideCloseBtn?: boolean
  handleSave?: () => void
  needSaveBtn?: () => boolean
  isFull?: boolean
  bordered?: boolean
}

const b = block('modal')

const Modal: React.FC<IModalProps> = ({
  open,
  handleClose,
  children,
  bgColor = 'none',
  position = 'default',
  hideCloseBtn = false,
  handleSave,
  needSaveBtn = false,
  isFull = false,
  bordered = true,
}) => {
  const locale = useSelector(selectLocaleDict).common
  const stop = (e: React.SyntheticEvent) => e.stopPropagation()

  useHideOverflow(open)

  const content = (
    <AnimatePresence exitBeforeEnter>
      {open && (
        <motion.div
          className={b({ isFull })}
          onMouseDown={handleClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}>
          <div className={b('wrapper', { position })}>
            <div className={b('app-container')}>
              <div
                className={b('content-container', { bordered })}
                style={{ backgroundColor: bgColor }}
                onMouseDown={stop}
                onMouseUp={stop}
                onClick={stop}>
                {needSaveBtn && (
                  <div className={b('save-block')}>
                    <Button text={locale.save} callback={handleSave} />
                  </div>
                )}
                {!hideCloseBtn && (
                  <div className={b('close-block')} onClick={handleClose}>
                    <CloseImg className={b('close-img')} />
                  </div>
                )}
                {children}
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )

  const node = document.getElementById('modal_root')
  if (node !== null) {
    return ReactDOM.createPortal(content, node)
  }
  return null
}

export default Modal
